import React from "react";
import { Link } from "react-router-dom";

import product1smpng from "../../../assets/images/product-1-sm.png";
import Shared from "../../../components/ReUseAbleComponents/Shared";

function Documentations(props) {
  return (
    <>
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap">
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Quantial – Moving Upon Signs Moveth Lesser
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Sensific – Saying Beast Lesser for in Fruitful
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Minist – Subdue Above for Signs Dry is Have Great
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Desty – She&#39;d Under Light Over Multiply Stars Winged
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Silies – Grass Living Fly Subdue After Fruitful
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Interra – Evening Were Set Beginning Image That One
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Explora – Open Winged Lights Spirit Very Subdue
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Thoute – Yielding Land Fill Gathering Midst Second
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Accountry – Saying Gathering Image Above Dominion
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Mained – Third Lights Greater Were Morning
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Treate – Blessed Which Give May Make Life Sea Days
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/single-documentation"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product1smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Priety – Living Given Night a in Itself Lesser Fowl
                </span>
              </Link>
            </div>
          </div>
          <div className="text-center mt-70">
            <Link
              to="/#"
              className="dx-btn dx-btn-grey dx-btn-lg dx-btn-load"
              data-btn-loaded="all products shown"
            >
              Load More
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Documentations;
